import type {
  AdvisorConfig,
  ComplianceConfig,
  EntitySnapshot,
} from '../bridge/protocol';
import type {ImageEntityResolver} from './image-resolver';
import type {AdvisorInput, ComplianceInput} from './canvas-chrome';

export interface ComplianceBootstrap {
  entities: EntitySnapshot[];
  compliance: ComplianceConfig | null;
  advisor: AdvisorConfig | null;
}

export function buildComplianceBootstrap(opts: {
  resolver: ImageEntityResolver;
  compliance: ComplianceInput | null;
  advisor: AdvisorInput | null;
}): ComplianceBootstrap {
  const {resolver, compliance, advisor} = opts;
  const entities: EntitySnapshot[] = [];

  let companyImageId: string | null = null;
  let dealerImageId: string | null = null;
  let avatarImageId: string | null = null;

  if (compliance?.companyLogo) {
    companyImageId = 'img:compliance:company';
    entities.push(
      resolver.create({
        publicId: companyImageId,
        ...compliance.companyLogo,
      }),
    );
  } else {
    resolver.forget('img:compliance:company');
  }
  if (compliance?.dealerEnabled && compliance.dealerLogo) {
    dealerImageId = 'img:compliance:dealer';
    entities.push(
      resolver.create({
        publicId: dealerImageId,
        ...compliance.dealerLogo,
      }),
    );
  } else {
    resolver.forget('img:compliance:dealer');
  }
  if (advisor?.avatar) {
    avatarImageId = 'img:compliance:advisor';
    entities.push(
      resolver.create({
        publicId: avatarImageId,
        ...advisor.avatar,
      }),
    );
  } else {
    resolver.forget('img:compliance:advisor');
  }

  return {
    entities,
    compliance: compliance
      ? {
          disclosure: compliance.disclosure,
          companyName: compliance.companyName,
          companyImageId,
          dealerEnabled: compliance.dealerEnabled,
          dealerName: compliance.dealerName,
          dealerImageId,
        }
      : null,
    advisor: advisor
      ? {
          name: advisor.name,
          email: advisor.email,
          avatarImageId,
        }
      : null,
  };
}
